import { render, staticRenderFns } from "./ProspectSearchSummaryCard.vue?vue&type=template&id=f1cb87aa&scoped=true&"
import script from "./ProspectSearchSummaryCard.vue?vue&type=script&lang=ts&"
export * from "./ProspectSearchSummaryCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProspectSearchSummaryCard.vue?vue&type=style&index=0&id=f1cb87aa&prod&lang=scss&scoped=true&"
import style1 from "./ProspectSearchSummaryCard.vue?vue&type=style&index=1&id=f1cb87aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cb87aa",
  null
  
)

export default component.exports